import { clientPresets } from './presets'
import type { ClientPreset } from './types'
import { env } from '@/shared/config/env'

const base = clientPresets[env.brandId]

export const clientConfig: ClientPreset = Object.freeze({
  ...base,
  name: env.siteName ?? base.name,
  displayDomain: env.siteNameUrl ?? base.displayDomain,
  siteUrl: env.siteUrl ?? base.siteUrl,
  links: {
    ...base.links,
    statusUrl: env.uptimeUrl ?? base.links.statusUrl,
    telegramUrl: env.telegramUrl ?? base.links.telegramUrl,
    contactEmail: env.contactEmail ?? base.links.contactEmail,
  },
  integrations: {
    googleClientId: env.googleClientId ?? base.integrations.googleClientId,
    turnstileSiteKey: env.turnstileSiteKey ?? base.integrations.turnstileSiteKey,
  },
})

export type { ClientPreset, ThemeMode, ThemeTokens } from './types'
export { clientPresets } from './presets'
